module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-thin-100.ttf";